import { render, staticRenderFns } from "./HamburgerMenu.vue?vue&type=template&id=bc4fc148&scoped=true&"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js&"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./HamburgerMenu.vue?vue&type=style&index=0&id=bc4fc148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4fc148",
  null
  
)

export default component.exports